import { render, staticRenderFns } from "./edit_price.vue?vue&type=template&id=cda8fa22&scoped=true&"
import script from "./edit_price.vue?vue&type=script&lang=js&"
export * from "./edit_price.vue?vue&type=script&lang=js&"
import style0 from "./edit_price.vue?vue&type=style&index=0&id=cda8fa22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda8fa22",
  null
  
)

export default component.exports